import React from "react";
import { Routes, Route, useLocation, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import useAuthStore from "../stores/useAuthStore";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Aside from "../components/Aside/Aside";
import pkg from "../../package.json";
import navRoutesTeacher from "../Routes/navRoutesTeacher";
import navRoutesSuperuser from "../Routes/navRoutesSuperuser";
import navRoutesStudent from "../Routes/navRoutesStudent";
import navRoutesAplSupervisor from "../Routes/navRoutesAplSupervisor";
import { FormattedMessage } from "react-intl";

function RouteElement({ Component, data }) {
  const { programId, classId, studentId } = useParams();
  return (
    <Component
      key={`${programId || ""}-${classId || ""}-${studentId || ""}`}
      data={data}
    />
  );
}

function Main() {
  const roles = useAuthStore((state) => state.roles);
  const location = useLocation();
  let displaySideBar = true;
  let navRoutes = [];

  switch (roles) {
    case "Student":
      navRoutes = navRoutesStudent;
      displaySideBar = true;
      break;
    case "Teacher":
      navRoutes = navRoutesTeacher;
      displaySideBar = true;
      break;
    case "Superuser":
    case "Admin":
      navRoutes = navRoutesSuperuser;
      break;
    case "AplSupervisor":
      navRoutes = navRoutesAplSupervisor;
      displaySideBar = false;
      break;
    default:
      break;
  }

  return (
    <div className="app">
      <Header />
      <div className={"app-body"}>
        {displaySideBar && <Sidebar />}

        <main className="main">
          <Breadcrumb />
          <Container fluid>
            <Routes>
              {navRoutes.map((route, idx) => {
                return route.component ? (
                  <Route
                    key={idx}
                    path={route.path}
                    element={
                      <RouteElement
                        Component={route.component}
                        data={route.props}
                      />
                    }
                  />
                ) : null;
              })}
            </Routes>
          </Container>
        </main>
        {(roles === "Superuser" || roles === "Admin") &&
          location.pathname === "/" && (
            <div
              style={{ position: "absolute", bottom: "1rem", right: "1rem" }}
            >
              <FormattedMessage id="Version" />: {pkg.version}
            </div>
          )}
        <Aside />
      </div>
    </div>
  );
}

export default Main;
